import { createPortal } from 'react-dom';
import { Button } from '@/components/ui/button';
import { useTutorial } from '@/components/tutorial/use-tutorial';
import useIsPWA from '@/hooks/use-is-pwa';

const FinishPopup = () => {
  const { showFinish, dismissFinish } = useTutorial();
  const isPWA = useIsPWA();
  const isMobile = isPWA || window.innerWidth < 1024;

  if (!showFinish || isMobile) return null;

  return createPortal(
    <div className="fixed inset-0 z-[70] flex items-center justify-center" onClick={dismissFinish}>
      <div className="absolute inset-0 bg-black/50" />
      <div
        className="relative bg-card rounded-3xl p-12 max-w-[460px] w-[92%] shadow-2xl text-center animate-[popIn_0.5s_cubic-bezier(0.34,1.56,0.64,1)]"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="text-6xl block mb-6 animate-[bounce_0.7s_0.2s_both]">{'\uD83C\uDF89'}</span>
        <h2 className="text-2xl font-extrabold text-foreground mb-2.5">
          Vous êtes prêt à rouler !
        </h2>
        <p className="text-sm text-muted-foreground leading-relaxed mb-7">
          Vous connaissez maintenant toutes les fonctionnalités de votre espace assuré. Bonne route, et on reste disponibles si besoin.
        </p>
        <Button onClick={dismissFinish} className="w-full cursor-pointer text-white font-bold text-[15px] py-3.5 rounded-xl">
          Accéder à mon espace {'\u2192'}
        </Button>
      </div>
    </div>,
    document.body,
  );
};

export default FinishPopup;
